import React from 'react';
import { IoDownloadOutline, IoLockClosed, IoExitOutline  } from 'react-icons/io5';
import { MdOutlineDashboard } from 'react-icons/md';
import { GiAustralia } from "react-icons/gi";

import './StatisticsSearchResultItem.scss';

/**
 * IStatisticsSearchResultDetails
 *
 * @description Properties required to render Statistics search result item
 */
interface IStatisticsSearchResultDetails {
  name: string;
  title: string;
  url: string;
  downloadUrl: string;
  icon: string;
}

/**
 * renderIcon
 *
 * @description Returns the corresponding Icon for the statistic publication. If it is a 'Download' it returns the link
 * @param icon - The type of icon to render.
 * @param downloadUrl - (Optional) The URL for downloading content. Used only when `icon` is 'Download'.
 * @returns The Icon component or an anchor tag containing the icon, based on the `icon` type and `downloadUrl`.
 */
const renderIcon = (icon: string, downloadUrl?: string) => {
  if (!icon) {
    return null;
  }

  switch (icon) {
    case 'Download':
      return downloadUrl ? (
        <a className='search-results-article__download-link' href={downloadUrl} title='Download link'>
          <IoDownloadOutline size={28} />
        </a>
      ) : (
        <IoDownloadOutline size={28} />
      );
    case 'Locked':
      return <IoLockClosed size={28} />;
    case 'Website':
      return <IoExitOutline size={28} />;
    case 'Dashboard':
      return <MdOutlineDashboard size={28} />;
    case 'Map':
      return <GiAustralia size={28} />;
    default:
      return null;
  }
};
  
/**
 * StatisticsSearchResultItem
 *
 * @description Component used to render Statistics search result
 */
const StatisticsSearchResultItem: React.FC<{ result: IStatisticsSearchResultDetails; }> = ({ result }) => {
  return (
    <article className='search-results-article'>
      <div>
        <h5>
          <a href={result.url}>{result.name}</a>
        </h5>
        <span>{result.title}</span>
      </div>
      {
        renderIcon(result.icon, (result.icon === 'Download' && result.downloadUrl) ? result.downloadUrl : undefined )
      }
    </article>
  );
};

export default StatisticsSearchResultItem;